import script from "./HomepageSidebarSegmentTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageSidebarSegmentTitle.vue?vue&type=script&setup=true&lang=js"

import "./HomepageSidebarSegmentTitle.vue?vue&type=style&index=0&id=29a831c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a831c8"]])

export default __exports__